import { Objects } from '../object-definitions'

export namespace Mls {
    export function convertToMlsProfile(mlsAgent: Objects.Mls.Agent): Objects.Establishment.Field.MlsProfile {
        const { email, fullName, mlsSource, mlsID, stateLicense, officePhone } = mlsAgent

        const agent: Objects.Establishment.Field.MlsProfile = {
            email: email,
            fullName: fullName,
            source: mlsSource,
            mlsId: mlsID,
            id: mlsAgent.id,
            stateLicense: stateLicense,
            officePhone: officePhone,
        }

        return agent
    }
}
